import { forwardRef } from "react";
import { MessageCircle } from "lucide-react";

const WhatsAppButton = forwardRef<HTMLAnchorElement>((_, ref) => {
  return (
    <a
      ref={ref}
      href="https://wa.me/919145863773?text=Hi%2C%20I%27m%20interested%20in%20rooftop%20solar%20panel%20installation."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[hsl(142_70%_45%)] flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="h-7 w-7 text-[hsl(0_0%_100%)]" />
    </a>
  );
});

WhatsAppButton.displayName = "WhatsAppButton";

export default WhatsAppButton;
